import Typography from "@mui/material/Typography";
import "../css/footer.css";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import footer_logo from "../image/catalog/demo/banners/footer-logo.png";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <>
      <div className="footer-cover">
        <div className="footer">
          <div className="div-1">
            <Typography variant="h5">
              <Link style={{ textDecoration: "none", color: "white" }} to="/">
                Med-Daily
              </Link>
            </Typography>
            <Typography style={{ color: "#565555" }} mt={3}>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime
              mollitia, molestiae quas vel sint commodi repudiandae consequuntur
              voluptatum laborum numquam blanditiis harum quisquam eius sed odit
              tempora.
            </Typography>
          </div>
          <div className="div-2">
            <Typography variant="h5" style={{ color: "#30d5c8" }}>
              Company
            </Typography>
            <Typography variant="h5" mt={3} style={{fontSize:"15px"}}>
              Business Partnership
            </Typography>
            <Typography variant="h5" mt={2} style={{fontSize:"15px"}}>
              <Link
                style={{ textDecoration: "none", color: "white" }}
                to="/privacy"
              >
                {" "}
                Privacy Policy
              </Link>
            </Typography>
            <Typography variant="h5" mt={2} style={{fontSize:"15px"}}>
              <Link
                style={{ textDecoration: "none", color: "white" }}
                to="/termscondition"
              >
                Terms & Conditions
              </Link>{" "}
            </Typography>
            <Typography variant="h5" mt={2} style={{fontSize:"15px"}}>
              Return Policy
            </Typography>
          </div>
          <div className="div-3">
            <Typography variant="h5" style={{ color: "#30d5c8" }}>
              <Link
                style={{ textDecoration: "none", color: "#30d5c8" }}
                to="/contactus"
              >
                Connect
              </Link>{" "}
            </Typography>
            <Typography variant="h5" mt={3} style={{fontSize:"15px"}}>
              <LocalPhoneIcon /> +91 8979694367
            </Typography>
            <Typography variant="h5" mt={2} style={{fontSize:"15px"}}>
              <EmailIcon /> info@Meddaily.in
            </Typography>
            <Typography variant="h5" mt={2} style={{ color: "#30d5c8" }} style={{fontSize:"15px"}}>
              Social Media
            </Typography>
            <br></br>
            <FacebookIcon fontSize="large" />
            <InstagramIcon fontSize="large" />
          </div>
        </div>
        <div className="footer-line"></div>
        <div className="copy-right">
          <div>
            <Link style={{ textDecoration: "none" }} to="/">
              <img src={footer_logo} alt="footer_logo" />
            </Link>
          </div>
          <div>
            {" "}
            <Link
              style={{ textDecoration: "none", color: "white",fontSize:"20px" }}
              to="/termscondition"
            >
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
